import { Typography, Button, Stack, Box, Tooltip } from '@mui/material'
import route from '../utils/Routes';
import { useNavigate } from 'react-router-dom';
import { isEmpty, isNotEmpty, makeTxtOverFLow } from '../utils/format';
import LabelTxt from './LabelTxt';
import { useEffect } from 'react';
import { useAuthContext } from '../context/AuthContext';
import { getFileUrl } from '../services/s3-service';
import { useQuery } from 'react-query';
import QueryKey from '../utils/QueryKey';
import BlurImg from './BlurImg';
import { Info } from '@mui/icons-material';

function ProductCard({ i, isComUser, type = "amtc", handleCardClick, mt, comId }) {
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 11, color: "rgb(0,0,0,0.4)", display: "inline-block", width: 80 }
    const typostyle = { fontSize: 12, fontWeight: 500, color: "rgba(0,0,0, 1)", display: "inline-block" };
    const handleClick = () => {
        if (handleCardClick) {
            handleCardClick(i)
        }
        else if (isComUser)
            navigate(`${route.cProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
        else if (type === "com")
            navigate(`${route.aComProdInfo}/?prodId=${i?.amtcProdIdStrg}&comId=${comId}`);
        else if (i?.isApproved === 0) {
            if (i?.createdBy === parseInt(ctxtUser?.userId || "0"))
                navigate(`${route.aApprCreatedProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
            else {
                navigate(`${route.aApprReqProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
            }
        }
        else
            navigate(`${route.aProduct}/?prodId=${i?.amtcProdIdStrg}`);
    };

    const { isLoading: isImgLoading, data: imgUrl } = useQuery([QueryKey.img, i?.prodDisImg],
        () => getFileUrl({ fileKey: i?.prodDisImg }), {
        enabled: isNotEmpty(i?.prodDisImg),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImgLoading]);

    // if (isImgErr) {
    //     customAlert(imgErr);
    //     return <h2>Something went wrong</h2>
    // }

    return (
        <>
            {/* <Stack direction={"row"} style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', }}> */}
            <Button onClick={handleClick} sx={{
                padding: 1, alignItems: "center", justifyContent: "center", border: 1, borderRadius: 4, boxShadow: 1,
                borderColor: "rgba(0,0,0,0.1)", width: 190, height: 200, mt: mt ?? 1, position: "relative"
            }}>
                <Stack direction={"column"} alignItems={'center'} >
                    <Box
                        sx={{
                            width: 130,
                            height: 120,
                            borderRadius: 4,
                            my: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden', // Ensure content doesn't overflow the box
                        }}
                    >
                        <BlurImg imgUrl={imgUrl} alt={"Product"} />
                    </Box>
                    <Box sx={{ mb: 0 }}>
                        <Tooltip title={i?.prodName}>
                            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "rgba(0,0,0, 1)" }} >{makeTxtOverFLow(i?.prodName.toString(), 18)}</Typography>
                        </Tooltip>
                        <LabelTxt typoname={"AMTC Ref PID"} typodetail={i?.amtcProdIdStrg} overflow={8} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        {(type !== "amtc" && (isNotEmpty(i?.comId))) && <LabelTxt typoname={"Mat Code"} typodetail={i?.comProdIdStrg ?? "NA"}
                            overflow={8} namestyle={typoHeadStyle} detailstyle={typostyle} />}
                    </Box>
                </Stack>
                {(type !== "amtc" && (isEmpty(i?.comId))) && <Box sx={{ position: "absolute", top: 2, right: 2 }}>
                    <Tooltip title="Not in Company Catalogue!" >
                        <Info color='warning' />
                    </Tooltip>
                </Box>}

            </Button>
            {/* </Stack> */}
        </>
    )
}

export default ProductCard
